export default {
  setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setSales(state, sales) {
    state.sales = sales;
  },
  setSale(state, sale) {
    state.sale = sale;
  },
  setTotalAmount(state, totalAmount) {
    state.totalAmount = totalAmount;
  },
  setTotalCount(state, totalCount) {
    state.totalCount = totalCount;
  },
  setTotalAmountBillet(state, totalAmountBillet) {
    state.totalAmountBillet = totalAmountBillet;
  },
  setTotalBillet(state, totalBillet) {
    state.totalBillet = totalBillet;
  },
  setFilterDates(state, filterDates) {
    state.filterDates = filterDates;
  },
  setInitiateCheckout(state, initiateCheckout) {
    state.initiateCheckout = initiateCheckout;
  },
  setInstallments(state, installments) {
    state.installments = installments;
  },
  setPickerType(state, datePickerType) {
    state.datePickerType = datePickerType;
  }
};
